import { useState, useEffect } from "react";

// react-router-dom components

// @mui material components
import Card from "@mui/material/Card";
import Switch from "@mui/material/Switch";
import _ from "lodash";
import FormHelperText from "@mui/material/FormHelperText";

// @mui icons

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "../../../components/MDInput";
import MDButton from "../../../components/MDButton";

// Authentication layout components
import BasicLayout from ".././components/BasicLayout";

// Images
import bgImage from "assets/images/bg-sign-in-basic.jpeg";

import { login, authTwoFactor } from "../../../domain/apis/authService";
import { setCookie, getCookie } from "common/CookieUtils";
import { useNavigate } from "react-router-dom";

function Basic() {
  const navigate = useNavigate();

  const [username, setUsername] = useState();
  const [password, setPassword] = useState();

  const [rememberMe, setRememberMe] = useState(getCookie("r") === "true");

  const handleSetRememberMe = () => setRememberMe(!rememberMe);

  const [tfa, setTFA] = useState({
    isTFA: false,
    session: "",
    code: "",
  });

  useEffect(() => {
    let t = getCookie("t") ?? "";
    if (t !== "") {
      setTimeout(() => {
        navigate("/dashboard");
      }, 1000);
    }
  }, []);

  const handleLogin = () => {
    login({ username, password }).subscribe({
      next({ data }) {
        const { accessToken, refreshToken, session } = data.data;
        if (_.isEmpty(session)) {
          setCookie("t", accessToken);
          setCookie("rt", refreshToken);
          setCookie("r", rememberMe);
          navigate("/dashboard");
        } else {
          setTFA({
            isTFA: true,
            session,
            code: "",
          });
        }
      },
      error(error) {
        console.log(error);
        alert("Đăng nhập thất bại");
      },
    });
  };

  const handleTFA = ({ session, code }) => {
    authTwoFactor({ session, code }).subscribe({
      next({ data }) {
        const { accessToken, refreshToken } = data.data;
        setCookie("t", accessToken);
        setCookie("rt", refreshToken);
        setCookie("r", rememberMe);
        navigate("/dashboard");
      },
      error(error) {
        console.log(error);
        alert(error.response.data.message);
      },
    });
  };

  return (
    <BasicLayout image={bgImage}>
      <Card>
        <MDBox
          variant="gradient"
          bgColor="info"
          borderRadius="lg"
          coloredShadow="info"
          mx={2}
          mt={-3}
          p={2}
          mb={1}
          textAlign="center"
        >
          <MDTypography variant="h4" fontWeight="medium" color="white" mt={1}>
            Đăng nhập
          </MDTypography>
        </MDBox>
        <MDBox pt={4} pb={3} px={3}>
          <MDBox component="form" role="form">
            {tfa.isTFA && (
              <>
                <MDBox mb={2}>
                  <MDInput
                    type="code"
                    label="Mã xác thực"
                    fullWidth
                    onChange={({ target }) =>
                      setTFA({
                        ...tfa,
                        code: target.value,
                      })
                    }
                  />
                </MDBox>
                <FormHelperText error id={`outlined-info`}>
                  <b>Vui lòng nhập mã xác thực từ ứng dụng authenticator!</b>
                </FormHelperText>
              </>
            )}
            {!tfa.isTFA && (
              <>
                <MDBox mb={2}>
                  <MDInput
                    type="email"
                    label="Email"
                    fullWidth
                    onChange={({ target }) => setUsername(target.value)}
                  />
                </MDBox>
                <MDBox mb={2}>
                  <MDInput
                    type="password"
                    label="Password"
                    fullWidth
                    onChange={({ target }) => setPassword(target.value)}
                  />
                </MDBox>
                <MDBox display="flex" alignItems="center" ml={-1}>
                  <Switch checked={rememberMe} onChange={handleSetRememberMe} />
                  <MDTypography
                    variant="button"
                    fontWeight="regular"
                    color="text"
                    onClick={handleSetRememberMe}
                    sx={{ cursor: "pointer", userSelect: "none", ml: -1 }}
                  >
                    &nbsp;&nbsp;Nhớ đăng nhập
                  </MDTypography>
                </MDBox>
              </>
            )}
            <MDBox mt={4} mb={1}>
              <MDButton
                variant="gradient"
                color="info"
                fullWidth
                onClick={() => {
                  if (tfa.isTFA) {
                    handleTFA(tfa);
                  } else {
                    handleLogin();
                  }
                }}
              >
                {tfa.isTFA ? "Xác thực" : "Đăng nhập"}
              </MDButton>
            </MDBox>
            {/* <MDBox mt={3} mb={1} textAlign="center">
              <MDTypography variant="button" color="text">
                Don&apos;t have an account?{" "}
                <MDTypography
                  component={Link}
                  to="/authentication/sign-up"
                  variant="button"
                  color="info"
                  fontWeight="medium"
                  textGradient
                >
                  Sign up
                </MDTypography>
              </MDTypography>
            </MDBox> */}
          </MDBox>
        </MDBox>
      </Card>
    </BasicLayout>
  );
}

export default Basic;
